import {config} from '@/assets/js/config/base'
import {storageLocal} from '@/assets/js/libs/localstorage'
export const auth = {
  loggedIn: function (to, from = null) {
    return new Promise((resolve, reject) => {
      storageLocal.get([config.local.jwtName, 'user_role'])
        .then(
          storage => {
            let jwtToken = storage[0]
            let role = parseInt(storage[1])
            if (to.meta.auth) {
              let roleMatch = -1
              let roles = to.meta.roles
              let expiration = 0
              if (jwtToken !== null) {
                let base64Url = jwtToken.split('.')[1]
                let base64 = base64Url.replace('-', '+').replace('_', '/')
                let payload = JSON.parse(window.atob(base64))
                expiration = payload.exp * 1000
              }
              let now = new Date().getTime()
              if (roles !== undefined) {
                roleMatch = roles.indexOf(role)
              }
              if (roleMatch === -1 || jwtToken === null || expiration < now) {
                resolve({
                  auth: false,
                  route: 'login'
                })
              } else {
                resolve({
                  auth: true,
                  route: 'continue'
                })
              }
            } else {
              if (jwtToken !== null && to.meta.roles === undefined) {
                resolve({
                  auth: true,
                  route: 'continue'
                })
              } else {
                resolve({
                  auth: false,
                  route: 'continue'
                })
              }
            }
          }
        )
    })
  },
  logout: function () {
    return new Promise((resolve) => {
      let fields = [config.local.jwtName, 'first_name', 'last_name', 'user_email', 'user_id', 'user_role', 'expires_in']
      let results = fields.map(element => {
        return Promise.resolve().then(function () {
          localStorage.removeItem(element)
        })
      })
      if (results) {
        resolve(results)
      }
    })
  },
  setSession: function (response) {
    return new Promise((resolve) => {
      let fields = [
        {
          field: config.local.jwtName,
          value: response.access_token
        },
        {
          field: 'first_name',
          value: response.name
        },
        {
          field: 'last_name',
          value: response.last_name
        },
        {
          field: 'user_email',
          value: response.email
        },
        {
          field: 'user_id',
          value: response.user_id
        },
        {
          field: 'user_role',
          value: response.role_id
        },
        {
          field: 'expires_in',
          value: response.expires_in
        }
      ]
      let results = fields.map(element => {
        return Promise.resolve().then(function () {
          localStorage.setItem(element.field, element.value)
        })
      })
      if (results) {
        resolve(results)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/libs/sessions.js